import * as S from './style';

function LoaderWithBackdrop() {
    return <S.Backdrop>
            <S.Loader />
    </S.Backdrop>
}

export default LoaderWithBackdrop